(function() {
    'use strict';
    /*
     * Copyright (c) 2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignForm', CampaignForm);

    /**
     * A directive for displaying and editing campaign form information.
     *
     * @ngdoc directive
     * @name campaign-form
     * @memberOf ihh-common-web
     */
    function CampaignForm() {
        return {
            restrict: 'AE',
            transclude: false,
            scope: {
                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.CampaignForm
                 */
                editFlag: '=',

                /**
                 * The scope variable that contains the state being edited (campaign and campaignTemp).
                 */
                state: '=',

                /**
                 * An already initialized clinic specialty chooser config.
                 */
                clinicSpecialtyConfig: '=',

                /**
                 * The scope variable that indicates whether this is a template-only campaign.
                 */
                isTemplate: '='
            },
            controller: 'CampaignFormCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaigns/campaign-form.tpl.html'
        };
    }
})();